module.exports = __webpack_public_path__ + "static/img/screenshot-bg.40ce4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-bg.png
// module id = 8bdc
// module chunks = 0